import { render, staticRenderFns } from "./DefaultCOA.vue?vue&type=template&id=a0d2ceb0&scoped=true&"
import script from "./DefaultCOA.vue?vue&type=script&lang=js&"
export * from "./DefaultCOA.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCOA.vue?vue&type=style&index=0&id=a0d2ceb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d2ceb0",
  null
  
)

export default component.exports